/* Stamped fills star badges present at page load. Cards added later
 * (Shop All tab switching, product recommendations, recently viewed, the
 * Build Your Own quick view) arrive as empty placeholders, so ask Stamped
 * to rescan whenever an unfilled badge appears.
 */
(() => {
  const EMPTY = '.stamped-product-reviews-badge[data-id]:not(:has(.stamped-badge))';
  let timer = null;

  const reload = () => {
    timer = null;
    if (!document.querySelector(EMPTY)) return;
    if (window.StampedFn && typeof window.StampedFn.loadBadges === 'function') {
      window.StampedFn.loadBadges();
    }
  };
  const schedule = () => {
    if (!timer) timer = setTimeout(reload, 250);
  };

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (node.matches('.stamped-product-reviews-badge') || node.querySelector('.stamped-product-reviews-badge'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Stamped's script can finish after ours; catch badges it has not filled */
  window.addEventListener('load', () => setTimeout(reload, 1500));
})();
